import { call, fork, put, takeEvery } from 'redux-saga/effects';
import { MAXIMUM_NUMBER_OF_RECOMMEND_TAG_ITEM_COUNT } from '../../../../constants/service/app/recommendTagConstants';
import { RECOMMEND_TAG_LIST_URL_PATH } from '../../../../constants/service/common/urlConstants';
import recommendTagToastMsg from '../../../../constants/service/toastMsg/recommendTagToastMsg';
import RecommendTagApi from '../../../../lib/api/recommend/tag/RecommendTagApi';
import {
  _setResponseListForm,
  asyncSimpleModal,
  reDirectPage,
  setMultipartForm,
  setRequestForm,
} from '../../../../lib/common';
import toastMsg from '../../../../lib/toastMsg';
import noticeExcelDownloadResult from '../../../../lib/noticeExcelDownloadResult';
import { recommendTagActions } from './index';

function* fetchList() {
  /**
   *   추천 태그 리스트 가져오기
   */
  yield takeEvery(recommendTagActions.GET_TAG_REVIEW_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendTagApi.getRecommendTagList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendTagToastMsg.GET_RECOMMEND_TAG_LIST_REQUEST_SUCCESS);

        const data = {
          recommendTagList: _setResponseListForm(result.data.recommendTagList, result.data.totalCnt, payload),
        };

        yield put({ type: recommendTagActions.GET_TAG_REVIEW_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(recommendTagToastMsg.GET_RECOMMEND_TAG_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *   추천 태그 상세 요청하기
   */
  yield takeEvery(recommendTagActions.GET_RECOMMEND_TAG_DETAIL_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendTagApi.getRecommendTagDetail, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendTagToastMsg.GET_RECOMMEND_TAG_DETAIL_REQUEST_SUCCESS);

        const data = {
          recommendTagDetail: {
            recommendTagInfo: result.data.recommendTagInfo,
            recommendTagItemList: result.data.recommendTagItemList,
          },
        };

        yield put({ type: recommendTagActions.GET_RECOMMEND_TAG_DETAIL_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(recommendTagToastMsg.GET_RECOMMEND_TAG_DETAIL_REQUEST_ERROR, error);
    }
  });

  /**
   *   추천 태그 복사하기 전 필요한 데이터 가져오기
   */
  yield takeEvery(recommendTagActions.PREPARE_COPY_RECOMMEND_TAG_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendTagApi.prepareCopyRecommendTag, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendTagToastMsg.PREPARE_COPY_RECOMMEND_TAG_REQUEST_SUCCESS);

        const data = {
          recommendTagSave: {
            recommendTagInfo: result.data.recommendTagInfo,
            selectedRecommendTagItemList: result.data.selectedRecommendTagItemList,
            recommendTagItemList: _setResponseListForm(
              result.data.recommendTagItemList.list,
              result.data.recommendTagItemList.totalCnt,
              payload,
            ),
          },
        };
        yield put({ type: recommendTagActions.PREPARE_COPY_RECOMMEND_TAG_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(recommendTagToastMsg.PREPARE_COPY_RECOMMEND_TAG_REQUEST_ERROR, error);
    }
  });

  /**
   *   추천 태그 등록하기 전 필요한 데이터 가져오기
   */
  yield takeEvery(recommendTagActions.PREPARE_CREATE_RECOMMEND_TAG_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendTagApi.prepareCreateRecommendTag, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendTagToastMsg.PREPARE_CREATE_RECOMMEND_TAG_REQUEST_SUCCESS);

        const data = {
          recommendTagSave: {
            recommendTagItemList: _setResponseListForm(
              result.data.recommendTagItemList.list,
              result.data.recommendTagItemList.totalCnt,
              payload,
            ),
          },
        };
        yield put({ type: recommendTagActions.PREPARE_CREATE_RECOMMEND_TAG_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(recommendTagToastMsg.PREPARE_CREATE_RECOMMEND_TAG_REQUEST_ERROR, error);
    }
  });

  /**
   *   추천 태그에 연결할 아이템 리스트 요청하기
   */
  yield takeEvery(recommendTagActions.GET_RECOMMEND_TAG_ITEM_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendTagApi.getRecommendTagItemList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendTagToastMsg.GET_RECOMMEND_TAG_ITEM_REQUEST_SUCCESS);

        const data = {
          recommendTagItemList: _setResponseListForm(
            result.data.recommendTagItemList.list,
            result.data.recommendTagItemList.totalCnt,
            payload,
          ),
        };
        yield put({ type: recommendTagActions.GET_RECOMMEND_TAG_ITEM_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(recommendTagToastMsg.GET_RECOMMEND_TAG_ITEM_REQUEST_ERROR, error);
    }
  });

  /**
   *   추천 태그 등록/복사하기
   */
  yield takeEvery(recommendTagActions.CREATE_RECOMMEND_TAG_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendTagApi.createRecommendTag, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendTagToastMsg.CREATE_RECOMMEND_TAG_REQUEST_SUCCESS);

        reDirectPage({ path: RECOMMEND_TAG_LIST_URL_PATH });
      }
    } catch (error) {
      toastMsg.error(recommendTagToastMsg.CREATE_RECOMMEND_TAG_REQUEST_ERROR, error);
    }
  });

  /**
   *   전체 태그 리스트 EXCEL 다운로드
   */
  yield takeEvery(recommendTagActions.GET_RECOMMEND_TAG_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendTagApi.getRecommendTagItemListExcelDownload, setRequestForm(payload, true));
      noticeExcelDownloadResult(payload.email, result.msg);
    } catch (error) {
      toastMsg.error(recommendTagToastMsg.GET_RECOMMEND_TAG_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR, error);
    }
  });

  /**
   *   선택된 태그 리스트 EXCEL 다운로드
   */
  yield takeEvery(
    recommendTagActions.GET_SELECTED_RECOMMEND_TAG_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST,
    function* ({ payload }) {
      try {
        const result = yield call(
          RecommendTagApi.getSelectedRecommendTagItemListExcelDownload,
          setRequestForm(payload, true),
        );
        noticeExcelDownloadResult(payload.email, result.msg);
      } catch (error) {
        toastMsg.error(recommendTagToastMsg.GET_SELECTED_RECOMMEND_TAG_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR, error);
      }
    },
  );

  /**
   *   태그 리스트 EXCEL 업로드
   */
  yield takeEvery(recommendTagActions.SET_RECOMMEND_TAG_ITEM_LIST_EXCEL_UPLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendTagApi.setRecommendTagItemListExcelUpload, setMultipartForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendTagToastMsg.SET_RECOMMEND_TAG_ITEM_LIST_EXCEL_UPLOAD_REQUEST_SUCCESS);

        /**
         *  추가하려고 하는 추천 상품 후기 아이템 개수가 초가되었을 경우
         *  업로드를 하지 못하도록 함
         */
        if (result.data.totalCnt > MAXIMUM_NUMBER_OF_RECOMMEND_TAG_ITEM_COUNT) {
          yield asyncSimpleModal({
            type: 'error',
            title: '아이템 개수 초과',
            message: `추천 태그 아이템 개수는 최대 ${MAXIMUM_NUMBER_OF_RECOMMEND_TAG_ITEM_COUNT} 입니다.`,
          });
          return;
        }

        yield put({ type: recommendTagActions.SET_RECOMMEND_TAG_ITEM_LIST_EXCEL_UPLOAD_SUCCESS, payload: result.data });
      }
    } catch (error) {
      toastMsg.error(recommendTagToastMsg.SET_RECOMMEND_TAG_ITEM_LIST_EXCEL_UPLOAD_REQUEST_ERROR, error);
    }
  });
}

export default function* widgetSaga() {
  yield fork(fetchList);
}
